<template>
  <div>
    <div class="row">
      <div class="pt-2 pb-1 col-12">
        <SectionTitle
          class="responsive-section-title"
          content="Información General"
          bg-icon="green"
          :has-line="true"
        />
      </div>
      <div class="col-md-4 col-12">
        <ValidationProvider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="model.requisitionType"
            label="Tipo de Requisión:"
            :options="collections.requisitionTypes"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            class="height-fixed"
            :error="errors[0]"
            custom-error-msg="El tipo de requisición es requerido."
          />
        </ValidationProvider>
      </div>
      <div v-if="isAuctionRequisition" class="col-md-4 col-12">
        <ValidationProvider v-slot="{ errors }" rules="required">
          <CustomInput
            v-model="model.supplierName"
            label="Nombre del Suplidor:"
            class="height-fixed"
            :error="errors[0]"
            custom-error-msg="El nombre del suplidor es requerido."
          />
        </ValidationProvider>
      </div>
      <div v-if="isAuctionRequisition" class="col-md-4 col-12">
        <ValidationProvider v-slot="{ errors }" rules="required">
          <CustomInput
            v-model="model.contractNumber"
            label="Número de Contrato:"
            class="height-fixed"
            :error="errors[0]"
            custom-error-msg="El número de contrato es requerido."
          />
        </ValidationProvider>
      </div>
      <div class="col-md-12 mt-2">
        <ValidationProvider v-slot="{ errors }" rules="required">
          <custom-text-area
            v-model="model.description"
            class=""
            label="Descripción:"
            :maxlength="3000"
            :rows="4"
            show-char-count
            :error="errors[0]"
            custom-error-msg="La descripción es requerida."
          />
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import CustomTextArea from 'CustomTextArea';
import common from '@/modules/common/code.api';
import requisitionTypes from '@/utils/constants/pei/materials-equipment-requisition/requisitionType.js';

export default {
  name: 'FormMaterialsEquipmentRequisition',
  components: {
    SectionTitle,
    CustomDropDown,
    CustomInput,
    CustomTextArea,
  },
  data() {
    return {
      model: {
        requisitionType: null,
        supplierName: null,
        contractNumber: null,
        description: null,
      },
      page: {
        icon: 'fas fa-user-edit',
        title: 'Manejo de Requisición de Materiales y Equipos',
        routes: [
          'Inicio',
          'PEI',
          'Manejo de Requisición de Materiales y Equipos',
        ],
      },
      collections: {
        requisitionTypes: [],
      },
    };
  },
  computed: {
    isAuctionRequisition() {
      return (
        this.model.requisitionType &&
        this.model.requisitionType.id == requisitionTypes.Auction
      );
    },
  },
  watch: {
    model: {
      deep: true,
      handler(value) {
        this.$emit('formDataChanged', value);
      },
    },
  },
  methods: {
    goToAddRequisition() {
      const self = this;
      self.$router.push({
        name: 'materialAddRequisition',
      });
    },
    async fetchRequisitionTypes() {
      const { data } = await common.getMaterialsequipmentRequisitionTypes();
      this.collections.requisitionTypes = data;
    },
  },
  mounted() {
    this.fetchRequisitionTypes();
  },
};
</script>
